import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
    changeCustomerMasterInitialState,
    handlePaginationStateCustomerMaster,
    setSelectedCustomerMaster,
    setShowCustomerMasterDetails,
} from "../../../store/customerMaster/customerMasterSlice";

const mapStateToProps = (state) => {
    return {
        // customer master
        formType: state.customerMaster.formTypeCustomerMaster,
        initialValues: state.customerMaster.initialValuesCustomerMaster,
        showDrawer: state.customerMaster.showDrawerCustomerMaster,
        pagination: state.customerMaster.paginationCustomerMaster,
        selectedCustomerMaster: state.customerMaster.selectedCustomerMaster,
        showCustomerMasterDetails: state.customerMaster.showCustomerMasterDetails,
    };
};

const mapDispatch = {
    changeCustomerMasterInitialState,
    handlePaginationState: handlePaginationStateCustomerMaster,
    setSelectedCustomerMaster,
    setShowCustomerMasterDetails,
};

const mapDispatchToProps = (dispatch) => bindActionCreators(mapDispatch, dispatch);

const Store = (Container) => connect(mapStateToProps, mapDispatchToProps)(Container);

export default Store;
